import * as types from './types';

const initialState = {
  sendUnreadLeadsMsgLoading: false,
  showUnreadLeadsModal: false,
  postingIds: [],
  sendUnreadLeadsMsgSuccess: false,
  sendUnreadLeadsMsgError: false,
  hasUnreadLeads: false,
  hasUnreadLeadsLoading: false,
  hasUnreadLeadsSuccess: false,
  hasUnreadLeadsError: false,
  postingIdsToEnd: null
};

function unreadLeadsMsgReducer(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_UNREAD_LEADS_MODAL:
      return {
        ...state,
        showUnreadLeadsModal: action.payload.showUnreadLeadsModal,
        postingIds: action.payload.postingIds,
        comesFromArchive: action.payload.comesFromArchive
      };

    case types.SEND_UNREAD_LEADS_MSG:
      return {
        ...state,
        sendUnreadLeadsMsgLoading: true,
        sendUnreadLeadsMsgSuccess: false,
        sendUnreadLeadsMsgError: false
      };

    case types.SEND_UNREAD_LEADS_MSG_COMPLETED:
      return {
        ...state,
        sendUnreadLeadsMsgLoading: false,
        sendUnreadLeadsMsgSuccess: true
      };
    case types.SEND_UNREAD_LEADS_MSG_FAILED:
      return {
        ...state,
        sendUnreadLeadsMsgLoading: false,
        sendUnreadLeadsMsgError: true
      };

    case types.HAS_UNREAD_LEADS:
      return {
        ...state,
        hasUnreadLeadsLoading: true,
        hasUnreadLeadsSuccess: false,
        hasUnreadLeadsError: false,
        postingIdsToEnd: null
      };

    case types.HAS_UNREAD_LEADS_COMPLETED:
      return {
        ...state,
        hasUnreadLeadsLoading: false,
        hasUnreadLeads: action.payload,
        hasUnreadLeadsSuccess: true,
        postingIdsToEnd: action.meta.query.postingIds
      };
    case types.HAS_UNREAD_LEADS_FAILED:
      return {
        ...state,
        hasUnreadLeadsLoading: false,
        hasUnreadLeadsError: true
      };

    case types.RESET_UNREAD_LEADS:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
}

export default unreadLeadsMsgReducer;
